<template>
  <el-form :class="['report-filter-run', initState && 'init-form']" :model='conditionValue' :rules="rules" ref="filterForm" :inline="true" @submit.native.prevent label-width="84px" label-position="right" :show-message="false">
     <el-row class="row-report-filter" ref="rowReportFilter">
          <el-col v-if="getFilters.length > 0" :style="{'height':displayMode?'inherit':'35px','width':filterWidth+'px'}" ref='filterCol' class="filterCol">
             <el-form-item v-for="(filter, filterIndex) in getFilters" :label="filter.name" :key="filter.id" :prop="filter.id" :title="filter.name.length>6?filter.name:''" :class="focusClass(filter, filterIndex)">
                <template v-if="filter.dataType.toLocaleLowerCase()==='enum'">
                    <el-select
                        :class="['filter-select', !filter.multipleChoic && 'filter-mutiple-select', !filter.multipleChoic && conditionValue[filter.id] instanceof Array && conditionValue[filter.id].length  === 1 && 'filter-only-one']"
                        reserve-keyword
                        clearable
                        filterable
                        :multiple="filter.multipleChoice"
                        collapse-tags
                        @visible-change="remoteMethod('', filter)"
                        v-model="conditionValue[filter.id]"
                        :placeholder="filter.placeholder"
                        :remote="filter.dataSource.remote"
                        :remote-method="(val) => remoteMethod(val, filter)"
                        :loading="loading"
                        @change="immediateSearch(filter)">
                      <el-option
                        v-for="(item,index) in options.filter[filter.id]"
                        :key="index"
                        :label="item.value"
                        :value="item.id">
                      </el-option>
                      </el-select>
                </template>
                <template v-else-if="filter.dataType.toLocaleLowerCase()==='date'">
                  <el-date-picker
                    v-model="conditionValue[filter.id]"
                    class="filter-select"
                    value-format="yyyy-MM-dd"
                    type="date"
                    :placeholder="filter.placeholder"
                    @change="immediateSearch(filter)">
                  </el-date-picker>
                </template>
                <template v-else-if="filter.dataType.toLocaleLowerCase()==='datetime'">
                  <el-date-picker
                    v-model="conditionValue[filter.id]"
                    class="filter-select"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    :placeholder="filter.placeholder"
                    @change="immediateSearch(filter)">
                  </el-date-picker>
                </template>
                <template v-else>
                    <el-input
                      :ref="filter.id"
                      class="filter-select"
                      :style="{'width': getWidth(filter.id)+'px' }"
                      v-model="conditionValue[filter.id]"
                      clearable
                      @keyup.enter.native="search"
                      :placeholder="filter.placeholder"
                      @input="immediateSearch(filter)"
                      @blur="isFirstFocus = false">
                    </el-input>
                </template>
              </el-form-item>
          </el-col>
          <el-col class="col-operation" :style="{'width':opereaWidth+'px'}">
            <el-form-item class="filter-buttons" v-if="reportFilters && reportFilters.length > 0">
              <!-- 有报表数据  或者 没有报表数据(说明是数据源弹窗的引用)-->
              <el-button @click="search" class="search-dropdown" v-if="getFilters.length>0">查询</el-button>
              <i v-if="moreShow" @click="closeOrOpen"  class="arrow"
                 :title="displayMode ? '收起':'展开'"
                 :class="[displayMode ? 'el-icon-d-arrow-left':'el-icon-d-arrow-right']" ></i>
              <i title="重置" v-if="getFilters.length > 0" class="el-icon-refresh" @click="reset"></i>
              <i title="高级筛选" v-if="report&&report.advancedFilter" class="el-icon-finished" @click="openSeniorFilter"></i>
            </el-form-item>
          </el-col>
     </el-row>
  </el-form>
</template>

<script>
import cache from '../../public/cache'
import _ from 'lodash'

export default {
  name: 'report-filter',
  inject: ['eventBus', 'leftMenu'],
  props: [ 'reportFilters', 'reportId', 'report', 'getButtonLength', 'componentWidth', 'buttonsLength', 'isRcDataSource', 'initFilterState' ],
  data () {
    let width = 0
    this.reportFilters.forEach(n => {
      if (!n.hidden && !n.filterHidden) {
        width = n.width ? width + n.width : width + 1
      }
    })
    return {
      logicPanelData: {
        filters: [],
        table: {},
        dialogVisible: false,
        expression: ''
      },
      conditionValue: {},
      rules: {},
      selectData: [],
      options: {
        filter: {
        }
      },
      displayMode: false,
      loading: false,
      filterWidth: 0,
      allFilterWidth: width,
      count: 0,
      initState: true,
      isFirstFocus: true
    }
  },
  mounted () {
    let componentWidth = this.componentWidth
    let leftMenuWidth = this.leftMenu.width
    if (componentWidth || !this.isRcDataSource) {
      setTimeout(() => {
        let operationWidth = this.buttonsLength ? this.buttonsLength.slice(0, -2) : 0
        let offsetWidth = componentWidth ? componentWidth - 5 : document.body.clientWidth - leftMenuWidth - 30 - operationWidth
        this.count = Math.floor((offsetWidth - 150) / 234)
        let width = this.allFilterWidth
        this.filterWidth = width <= this.count ? width * 234 : this.count * 234
        // 如果能找到有设置了勾选模式的筛选项，宽度需要减去166
        let filterReport = this.report && this.report.filters.filter(f => f.moreType)
        if (filterReport && filterReport.length > 0) {
          if (this.report.filters.filter(f => !f.moreType).length > this.count) {
            this.filterWidth = this.filterWidth - 166
          }
        }
        this.$refs.filterForm && this.$refs.filterForm.clearValidate()
        this.initState = false
      }, 300)
    } else if (!componentWidth && this.isRcDataSource) {
      //  华奥个别表单数据源控件，接口慢。特殊处理
      let val = 650
      let offsetWidth = val - 5
      this.count = Math.floor((offsetWidth - 150) / 234)
      let width = this.allFilterWidth
      this.filterWidth = width <= this.count ? width * 234 : this.count * 234
      // 如果能找到有设置了勾选模式的筛选项，宽度需要减去166
      let filterReport = this.report && this.report.filters.filter(f => f.moreType)
      if (filterReport && filterReport.length > 0) {
        if (this.report.filters.filter(f => !f.moreType).length > this.count) {
          this.filterWidth = this.filterWidth - 166
        }
      }
      this.$refs.filterForm && this.$refs.filterForm.clearValidate()
      this.initState = false
    }
  },
  computed: {
    opereaWidth () {
      let width = 0
      width = this.moreShow ? 150 : 125
      return width
    },
    moreShow () {
      if (this.allFilterWidth <= this.count) {
        return false
      } else {
        return true
      }
    },
    getFilters () {
      let filter = this.$_.clone(this.reportFilters) || []
      // 需要过滤开启了更多模式的下拉选项
      filter = filter.filter(m => !m.hidden && !m.moreType)
      filter.forEach(m => {
        if (typeof (m.position) === 'string') {
          m.position = JSON.parse(m.position)
        }
      })
      filter = filter.filter(m => !m.filterHidden)
      return this.$_.sortBy(filter, item => {
        return item.position.row * 10 + item.position.col
      })
    },
    focusClass () {
      return (filter, index) => {
        if (index === 0 && !['enum', 'date', 'datetime'].includes(filter.dataType) && this.isFirstFocus) {
          // 当前筛选项还未渲染
          this.setFocus(filter)
          return 'first-focus-input'
        }
      }
    }
  },
  methods: {
    setFocus (filter) {
      setTimeout(() => {
        this.$refs[filter.id] && this.$refs[filter.id][0].focus()
      }, 500)
    },
    closeOrOpen () {
      this.displayMode = !this.displayMode
      this.$emit('closeOrOpen', this.displayMode)
    },
    init () {
      this.initFilter()
      this.initSelectFilter()
      this.watchFilterDefaultValue()
    },
    watchFilterDefaultValue () {
      this.reportFilters.forEach(m => {
        let listenObject = []
        if (m.dataSource && m.dataSource.enable === true) {
          m.dataSource.filter && Object.keys(m.dataSource.filter).forEach(n => {
            // 如果筛选项的远程搜索筛选条件选了他自身要排除掉，否则自身改变时也会清空自身导致无法选中
            if (m.dataSource.filter[n] === m.id) return false
            listenObject.push(m.dataSource.filter[n])
          })
          if (listenObject.length > 0) {
            this.$watch(() => {
              let watchObj = []
              listenObject.forEach(m => {
                watchObj.push(this.conditionValue[m])
              })
              return watchObj
            }, _.debounce((newValue, oldValue) => {
              // 找到改变的筛选项的值，然后找到是哪个筛选项的filter里面包含这个改变筛选项，进行数据加载和清空值
              let differenceValue = Array.from(new Set(_.difference(newValue, oldValue)))
              differenceValue && differenceValue.forEach(el => {
                for (let key in this.conditionValue) {
                  if (this.conditionValue[key] === el) {
                    let filter = this.reportFilters.find(n => n.dataSource.filter && JSON.stringify(n.dataSource.filter).includes(key))
                    filter && this.resetHasFilterOption(filter)
                  }
                }
              })
            }, 100))
          }
        }
      })
    },
    findFilterType (type) {
      let filterType = ''
      switch (type) {
        case 'EqualsTo':
          filterType = '等于'
          break
        case 'NotEqualsTo':
          filterType = '不等于'
          break
        case 'GreaterThan':
          filterType = '大于'
          break
        case 'GreaterThanEquals':
          filterType = '大于等于'
          break
        case 'MinorThan':
          filterType = '小于'
          break
        case 'MinorThanEquals':
          filterType = '小于等于'
          break
        case 'LikeExpression':
          filterType = '包含'
          break
        case 'IsNull':
          filterType = '空'
          break
        case 'IsNotNull':
          filterType = '非空'
          break
        default:
          break
      }
      return filterType
    },
    initFilter () {
      if (this.reportFilters) {
        this.reportFilters.forEach(m => {
          // 需要过滤开启了更多模式的选项
          if (!m.moreType) {
            if (m.dataType === 'enum' && m.multipleChoice) {
              m.defaultValue && this.$set(this.conditionValue, m.id, [m.defaultValue])
            } else {
              m.defaultValue && this.$set(this.conditionValue, m.id, m.defaultValue)
            }
            if (m.required) {
              let rule = []
              rule.push({required: true, message: `${m.name}必填`, trigger: 'blur'})
              this.$set(this.rules, m.id, rule)
            }
          }
        })
      }
    },
    initParams (m) {
      let params = {'index': 1, 'size': 50, filters: {}}
      // 有dataSource.filter需要先看绑定的筛选条件是否有值
      if (m.dataSource.filter && Object.keys(m.dataSource.filter).length !== 0) {
        Object.keys(m.dataSource.filter).forEach(el => {
          params.filters[el] = this.conditionValue[m.dataSource.filter[el]]
        })
        this.searchOptions(params, m)
      } else {
        this.searchOptions(params, m)
      }
    },
    initSelectFilter () {
      if (this.reportFilters) {
        this.reportFilters.forEach(m => {
          if (m.dataType === 'enum' && m.dataSource.enable) {
            // 开启远程搜索的没有默认的选项
            if (!m.dataSource.remote) {
              this.initParams(m)
            }
          } else {
            let rows = m.template && m.template.stringOptions && m.template.stringOptions.trim().split('\n').map(el => {
              return {value: el, id: el}
            })
            this.$set(this.options.filter, m.id, rows)
          }
        })
      }
    },

    resetHasFilterOption (m) {
      this.initParams(m)
      this.$set(this.conditionValue, m.id, '')
    },
    searchOptions (params, m, query) {
      let cloneParamsFilters = params['filters']
      for (let key in cloneParamsFilters) {
        if (cloneParamsFilters[key]) {
          // 多选处理
          if (cloneParamsFilters[key] instanceof Array) {
            cloneParamsFilters[key] = cloneParamsFilters[key].join(', ')
          }
          cloneParamsFilters[key] = cloneParamsFilters[key].trim()
        }
      }
      params.filters = cloneParamsFilters

      cache.getData(`/report-api/report/data/${m.dataSource.reportId}`, params).then((data) => {
        let rows = data.map(n => {
          return {id: n[m.dataSource.columnId], value: n[m.dataSource.showColumnId]}
        })
        this.loading = false
        this.$set(this.options.filter, m.id, rows)
      })
    },

    remoteMethod (query, filter) {
      if (filter.dataSource.remote) {
        this.loading = true
        this.remoteLoadDataSourceOptions(query, filter)
      }
    },
    remoteLoadDataSourceOptions (query, filter) {
      let params = {'index': 1, 'size': 50, filters: {}}
      if (filter.dataSource.filter && Object.keys(filter.dataSource.filter).length !== 0) {
        Object.keys(filter.dataSource.filter).forEach(m => {
          // 如果是当前这个输入框的就传query , 其他框的就传 conditionValue
          if (filter.dataSource.filter[m] === filter.id) {
            params.filters[m] = query
          } else {
            params.filters[m] = this.conditionValue[filter.dataSource.filter[m]] || ''
          }
          this.searchOptions(params, filter, query)
        })
      } else {
        params.filters[filter.dataSource.showColumnId] = query
        this.searchOptions(params, filter, query)
      }
    },
    search () {
      if (this.initFilterState) return false
      Object.keys(this.conditionValue).forEach(m => {
        if (typeof (this.conditionValue[m]) === 'string') {
          this.conditionValue[m] = this.conditionValue[m].trim()
        }
      })
      this.$refs['filterForm'].validate((valid) => {
        if (valid) {
          if (this.isRcDataSource) {
            // 57期数据源弹窗的报表传参特殊处理
            this.$emit('search', {condition: this.conditionValue, isemit: true})
          } else {
            this.$emit('search', this.conditionValue)
          }
        }
      })
    },
    reset () {
      if (this.initFilterState) return false
      this.eventBus.$emit('filter.reset', this)
      this.reportFilters.forEach(m => {
        this.$set(this.conditionValue, m.id, m.defaultValue)
      })
      this.$emit('reset')
    },
    getWidth (filterId) {
      let width = 140
      let myFilter = this.reportFilters.find(item => {
        return item.id === filterId
      })
      if (myFilter.columnId.split('|').length >= 2) {
        width = 374
      }
      switch (myFilter.width) {
        case 2:
          width = 374
          break
        case 3:
          width = 606
          break
        case 4:
          width = 842
          break
        default:
          width = 140
          break
      }
      return width
    },
    openSeniorFilter () {
      this.$emit('openSeniorFilter')
    },
    openBatchHandle () {
      this.$emit('openBatchHandle')
    },
    // 及时搜索
    immediateSearch: _.debounce(function (filter) {
      filter.immediate && this.search()
    })
  }
}

</script>
 <style lang="scss">
  .report-filter-run {
    /*筛选项样式，去除默认的左外边距*/
    margin-left: 0!important;
    .row-report-filter {
        .filter-select.el-input,.el-select,.el-date-editor {
          width: 140px;
        }
    }
    .filterCol {
      margin-right: 0;
      overflow: hidden;
      .el-select {

        >div.el-select__tags {
          display: flex;
          width: 100%;
          flex-wrap: nowrap;
          .el-select__input{
            margin-left: 2px;
          }
          >span {

            >span:nth-child(1) {
              display: flex;
              max-width: 108px;
              overflow: hidden;
              width: 30%;
              .el-select__tags-text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .el-icon-close {
                width: 18px;
                top: 4px;
              }
            }
             >span:nth-child(2) {
               margin: 2px 0 2px 4px;
             }
          }

          .el-select__input {
            display: inline-block;
          }
        }

      }
      .el-form-item {
        .el-form-item__label {
          padding-top: 1.5px;
        }
        .el-form-item__content {
          .el-input {
            .el-input__inner {
              height: 25px;
              line-height: 25px;
              margin-top: 3px;
            }
          }
        }
      }
      .first-focus-input {
        .el-form-item__content {
          .el-input {
            .el-input__inner:focus {
              border-color: var(--primary, #76b7eb);
            }
          }
        }
      }
      .filter-mutiple-select {
        div.el-select__tags {
          max-width: 115px!important;
          .el-tag {
            .el-select__tags-text {
              font-size: 11px;
            }
            i.el-tag__close, i.el-icon-close {
              display: none;
            }
          }
        }
        .el-input__suffix {
          right: 0;
        }
      }
      .filter-only-one {
        div.el-select__tags {
          > span > span:nth-child(1) {
            width: 50%;
          }
        }
      }
    }
    .col-operation {

      .filter-buttons {
        margin-bottom: 12px;
        .el-button--mini,
        .el-button--mini.is-round {
          border: 1px solid var(--primary, #55ACF1);
          color: var(--primary, #55ACF1);
          padding: 5px;
          vertical-align: middle;
        }
        .arrow{
          transform:rotate(90deg)
        }
        :focus {
          outline: 0;
        }
        .search-dropdown {
          span {
            font-size: 12px;
          }

          .el-dropdown__caret-button {
            width: 21px;
            padding: 5px 2px;
            height: 24px;
            border-left: transparent;

            .el-icon-arrow-down {
              margin: 0;
            }
          }
        }
        i{
          margin-left: 12px;
          cursor: pointer;
          -moz-user-select: none;
          -o-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
        i:hover {
          color: var(--primary, #55ACF1);
        }
      }
      .batch-button{
        padding: 5px;
        margin-bottom: 8px;
        border: 1px solid var(--primary, #55ACF1);
        color: var(--primary, #55ACF1);
        vertical-align: middle;
      }
    }

    .el-form-item {
      .el-form-item__label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .init-form {
    .el-row {
      .filterCol {
        .is-error {
          .el-form-item__content {
            .el-form-item__error {
              display: none;
            }
            .el-input__inner {
              border-color: #DCDFE6;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-filter.vue